//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbModal from '@/elements/modal/rb-modal.vue'

import RbAfterpayContent from '@/elements/pay-over-time/afterpay/rb-afterpay-content.vue'

import { createNamespacedHelpers, mapState } from 'vuex'

const { mapGetters: mapGettersPdp } = createNamespacedHelpers('pdp')

import wcs from '@/scripts/libs/wcs'
export default {
  name: 'rb-afterpay-modal',
  components: {
    RbAfterpayContent,
    RbModal,
  },
  props: {
    afterpayIsVisible: {
      type: Boolean,
      default: false,
    },
    prices: {
      type: Object,
      default: () => ({
        discountedPrice: undefined,
        listPrice: '',
        promo: undefined,
        priceFormat: '',
        currencySymbol: '',
      }),
    },
  },
  computed: {
    ...mapState({
      showMinicart: (state) => state.sidebar.cart.show,
    }),
    ...mapGettersPdp(['ui']),
    getModalWrapperClass() {
      let wrapperClass = ''
      if (wcs.isInPdp()) {
        wrapperClass = 'main'
      } else if (wcs.isInCart() || wcs.isInFluidPcp()) {
        wrapperClass = 'footer'
      } else {
        wrapperClass = 'checkout'
      }
      return wrapperClass
    },
    isModalVisible() {
      return this.ui.afterPayModalActive && !this.showMinicart
    },
  },
  beforeDestroy() {
    this.closeModal()
  },
  methods: {
    closeModal() {
      this.$emit('closed')
    },
  },
}
